import Swiper from 'swiper';

$(function () {
  if ($('body').find('.anchorNavigationTarget').length > 0) {
    initiateAnchorNav();
  }
  if ($('body').find('#anchorNav').length > 0) {
    initializeAnchorNavSlider();
  }
});

$(window).resize(function () {
  if ($('body').find('.anchorNavigationTarget').length > 0) {
    initiateAnchorNav();
  }
});

$(window)
  .scroll(function () {
    if ($('body').find('.anchorNavigationTarget').length > 0) {
      setAnchorNavState();
      setActive();
    }
  })
  .scroll();

function initializeAnchorNavSlider() {
  var sliderAnchorNav = new Apocore.ApoSwiper('#sliderAnchorNav', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    navigation: {
      nextEl: '.anchorNavButtonNext',
      prevEl: '.anchorNavButtonPrev',
    },
    watchOverflow: true,
    normalizeSlideIndex: true,
    on: {
      transitionEnd: function () {
        setPositionClass();
      },
    },
  });

  function setPositionClass() {
    if (sliderAnchorNav.isBeginning) {
      $('#anchorNav').addClass('isBeginning');
      $('#anchorNav').removeClass('isEnd');
    } else if (sliderAnchorNav.isEnd) {
      $('#anchorNav').addClass('isEnd');
      $('#anchorNav').removeClass('isBeginning');
    } else {
      $('#anchorNav').removeClass('isBeginning');
      $('#anchorNav').removeClass('isEnd');
    }
  }

  setPositionClass();

  // Add focus event listener to update swiper translation on focused element
  $('#sliderAnchorNav .swiper-slide a').on('focus', function () {
    var index = $(this).closest('.swiper-slide').index();
    sliderAnchorNav.slideTo(index);
  });
}

function initiateAnchorNav() {
  var windowWidth =
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  var anchorNav = $('.anchorNav');
  if (anchorNav.length === 0) return;
  if (anchorNav.offset()) {
    anchorNav.attr('data-anchorNavInitialTop', anchorNav.offset().top);
  }
  $('.anchorNavList a').bind('click', function (e) {
    e.preventDefault();
    var target = $(this).attr('href');
    if ($(target).offset()) {
      var scrollTop = $(target).offset().top;
    }
    if (windowWidth >= 1024) {
      scrollTop = anchorNav.hasClass('sticky')
        ? $(target).offset().top - 75
        : $(target).offset().top - 135;
    }
    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: scrollTop,
        },
        500,
        function () {
          $(target).attr('tabindex', '-1').focus();
          $(target).removeAttr('tabindex');
        }
      );
    return false;
  });
}

function setAnchorNavState() {
  var anchorNav = $('.anchorNav');
  var pageYOffset = $(window).scrollTop();
  if (pageYOffset >= anchorNav.attr('data-anchorNavInitialTop')) {
    setSticky();
  } else {
    unsetSticky();
  }

  function unsetSticky() {
    anchorNav.removeClass('sticky');
    anchorNav.find('.anchorNavList a.active').removeClass('active');
  }

  function setSticky() {
    anchorNav.addClass('sticky');
  }
}

function setActive() {
  var anchorNav = $('.anchorNav');
  var pageYOffset = $(window).scrollTop() + 55 + 60; // height of the navigation plus safety area
  var components = $('section[id]');
  if (anchorNav.hasClass('sticky')) {
    for (var i = 0; i < components.length - 1; i++) {
      if (
        $(components[i]).offset().top <= pageYOffset &&
        $(components[i + 1]).offset() &&
        $(components[i + 1]).offset().top > pageYOffset
      ) {
        $('.active', anchorNav).removeClass('active');
        $('a[href="#' + $(components[i]).attr('id') + '"]', anchorNav).addClass('active');
      }
    }
    if (
      components.last().offset() &&
      components.last().offset().top + components.last().outerHeight < pageYOffset
    ) {
      $('.active', anchorNav).removeClass('active');
    }
  } else {
    $('.active', anchorNav).removeClass('active');
  }
}
